module.exports = __webpack_public_path__ + "img/DealerIcons-PDM-On.3113ff4.jpg";